import { MoxieImage } from "@/components/common/images/moxieImage";
import { GREY } from "@/config/mui/colorPalette";

export const MedspaLogo = ({
  medspaName,
  medspaLogoUrl,
}: {
  medspaName: string;
  medspaLogoUrl: string;
}) => {
  return (
    <MoxieImage
      imageUrl={medspaLogoUrl}
      width={80}
      height={80}
      alt={`${medspaName} logo`}
      style={{
        borderRadius: "50%",
        border: `1px solid ${GREY[40]}`,
      }}
    />
  );
};
